import Super from 'ember-simplepractice/models/insurance-provider-name';

export default class InsuranceProviderName extends Super {}
